export default "__VITE_ASSET__Bxp9FeHk__"